export default function scrollToError() {
  document.getElementsByClassName("Mui-error")[0]?.scrollIntoView({
    behavior: "smooth",
    block: "center",
    inline: "nearest",
  });
}
